<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">상품관리</span>
            <span class="txt">센터에서 이용 중인 이용권과 패키지를 등록 및 수정하고 설정할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <router-link :to="{ name: 'SettingGoodsUse' }">이용권 관리</router-link>
            <!-- <router-link :to="{ name: 'SettingGoodsPackage' }">패키지 관리</router-link> -->
            <router-link :to="{ name: 'SettingGoodsCategory' }" class="on">카테고리 관리</router-link>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-radio-txt">
                    <input
                        id="category-no"
                        v-model="filter.centerProductCategoryTemplateId"
                        :value="0"
                        checked
                        name="category"
                        type="radio"
                    />
                    <label for="category-no">선택안함</label>
                </div>
                <div class="com-radio-txt">
                    <input
                        id="category-all"
                        v-model="filter.centerProductCategoryTemplateId"
                        name="category"
                        type="radio"
                        value=""
                    />
                    <label for="category-all">전체</label>
                </div>
                <div class="com-radio-txt">
                    <select-form
                        :select-data="['선택', ...categorysData]"
                        :select-value="['0', ...categorysValues]"
                        :selected-value="filter.centerProductCategoryTemplateId || '0'"
                        @update:set="
                            (val) => {
                                filter.centerProductCategoryTemplateId = val;
                            }
                        "
                    ></select-form>
                </div>
                <!-- 2024.03.04 셀렉트로 박스 변경
        <select-form :select-data="categorysData" :select-value="categorysValues" :selected-value="" @update:set='val => {}' ></select-form>
        <div v-for='(item, index) in categorysData' :key='index' class='com-radio-txt'>
          <input
              :id="'category-' + index"
              v-model='filter.centerProductCategoryTemplateId'
              :value='categorysValues[index]'
              name='category'
              type='radio'
          />
          <label :for="'category-' + index">{{ item }}</label>
        </div>
        -->
                <button class="com-setting-btn" @click="categoryPop = true"><span class="blind">설정</span></button>
                <div class="com-search-input">
                    <select-form
                        :select-data="['전체', '판매중', '판매정지']"
                        :select-value="['', 'true', 'false']"
                        :selected-value.sync="filter.stockUseYn"
                        @update:set="(v) => load()"
                    ></select-form>
                    <input
                        v-model="searchStr"
                        placeholder="이용권 입력"
                        type="text"
                        style="margin-left: 10px"
                        @keydown.enter="filter.searchStr = searchStr"
                    />
                    <button class="search-btn" type="button" @click="filter.searchStr = searchStr">검색</button>
                </div>
            </div>
        </div>

        <div class="com-btn-area">
            <div class="right-box">
                <button
                    :disabled="selectedItems.length == 0"
                    class="com-btn"
                    type="button"
                    @click="categoryMovePop = true"
                >
                    이동
                </button>
                <button
                    :disabled="filter.centerProductCategoryTemplateId == ''"
                    class="com-btn red"
                    type="button"
                    @click="unsetCategories"
                >
                    삭제
                </button>
            </div>
        </div>

        <!-- 상품목록 -->
        <div class="lesson-info-content white-bg">
            <loading-spinner v-if="isLoading"></loading-spinner>
            <ul v-else class="list">
                <!-- type-1: 개인, type-2: 그룹, type-3: 패키지, type-4: 회원권, type-5: 듀엣, type-6: OT -->
                <li v-for="(item, index) in data.items" :key="index">
                    <span v-if="!item.cp_stoc_use_yn" class="no">미사용</span>

                    <div class="com-check" :style="!item.cp_stoc_use_yn ? 'left:80px;' : 'left:25px;'">
                        <input
                            :id="'items-' + index"
                            :ref="'items-' + index"
                            v-model="selectedItems"
                            :value="item.cp_center_prod_id"
                            name="selected-items"
                            type="checkbox"
                            @click="selectItem(item.cp_center_prod_id)"
                        />
                        <label :for="'items-' + index"></label>
                    </div>

                    <span class="icon-box">
                        <span :class="'type-' + (ticketTypes.indexOf(item.cp_ticket_type_cd) + 1)" class="ico">
                            {{ ticketData[ticketTypes.indexOf(item.cp_ticket_type_cd)] }}
                        </span>
                    </span>
                    <span :class="'type-' + (ticketTypes.indexOf(item.cp_ticket_type_cd) + 1)" class="title">
                        {{ item.cp_namee }}
                    </span>
                    <span class="info">
                        {{ item.cp_less_cnt }}회 / 유효기간 {{ item.cp_period_cnt
                        }}{{ item.cp_period_type_cd == 'M' ? '개월' : '일' }} /
                        {{ (item.cp_category_temp_nm || '').replace(/\|/g, ' / ') }}
                    </span>
                    <span class="num">
                        {{ item.cp_sell_price | numberFormatFilter }}
                        <small>원</small>
                    </span>
                </li>
            </ul>
        </div>

        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>

        <!-- 카테고리 설정 팝업 -->
        <div v-show="categoryPop" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="categoryPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">카테고리 설정</span>
                    <p class="sub-txt">
                        카테고리의 이름을 추가, 수정 및 삭제 할 수 있습니다.
                        <br />
                        카테고리 삭제 시, 이전에 작성된 해당 카테고리의 게시글은 카테고리가 없이 표시됩니다.
                    </p>
                    <div class="del-box">
                        <div class="input-cnt flex-col">
                            <div v-for="(item, index) in categorys" :key="index" class="line">
                                <input :ref="'category-' + index" v-model="item.name" type="text" />
                                <button class="com-btn" @click="removeCategory(index)">
                                    삭제
                                </button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button v-if="categorys.length < 20" class="com-btn" @click="addCategory">+추가</button>
                            </div>
                            <p class="txt">
                                <span class="imp">*</span>
                                최대 20개까지 추가 가능합니다.
                            </p>
                        </div>
                    </div>
                </div>
                <loading-spinner v-if="isCategorySaving"></loading-spinner>
                <div v-else class="bottom-btn">
                    <button class="com-btn" type="button" @click="categoryPop = false">취소</button>
                    <button class="com-btn blue" type="button" @click="saveCategorys">저장</button>
                </div>
            </div>
        </div>

        <!-- 카테고리 이동 설정 팝업 -->
        <div v-show="categoryMovePop" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="categoryMovePop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">카테고리 이동</span>
                    <p class="sub-txt">
                        선택한 이용권의 카테고리를 이동할 수 있습니다.
                        <br />
                        하나의 이용권이 중복으로 카테고리에 들어갈 수 있습니다.
                    </p>
                    <div class="check-design-box">
                        <div class="input-cnt flex-col">
                            <div v-for="(item, index) in categorysData" :key="index" class="line">
                                <input
                                    :id="'category-check-' + index"
                                    v-model="categorysMove"
                                    :value="categorysValues[index]"
                                    name="category-check"
                                    type="checkbox"
                                />
                                <label :for="'category-check-' + index">{{ item }}</label>
                            </div>
                        </div>
                        <p class="info-txt">카테고리를 2개 이상 선택할 수 있습니다.</p>
                    </div>
                </div>
                <loading-spinner v-if="isCategorySaving"></loading-spinner>
                <div class="bottom-btn">
                    <button class="com-btn" type="button" @click="categoryMovePop = false">취소</button>
                    <button class="com-btn blue" type="button" @click="moveCategory">이동</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'SettingGoodsCategory',
    components: { LoadingSpinner },
    props: {},
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            categoryPop: false,
            categoryMovePop: false,
            isLoading: false,
            isCategorySaving: false,
            ticketData: [],
            ticketTypes: [],
            categorysData: [],
            categorysValues: [],
            categorysClone: [],
            categorysRemove: [],
            categorysMove: [],
            categorys: [],
            filter: {},
            searchStr: '',
            data: [],
            selectedItems: [],
            pagingInfo: { ...pagingInfo },
        };
    },
    watch: {
        categoryPop(v) {
            if (!v) this.categorysRemove = [];
            this.categorys = _.clone(this.categorysClone);
        },
        categoryMovePop(v) {
            if (!v) {
                this.categorysMove = [];
                this.selectedItems = [];
            }
        },
        filter: {
            handler(val) {
                const query = JSON.parse(JSON.stringify(val));
                delete query.sortType;
                this.$router.replace({
                    query,
                    replace: true,
                });
            },
            deep: true,
        },
    },
    async beforeMount() {
        this.pagingInfo.limit = 12;
        this.filter = this.getFilterDefault();
        (await this.$getSystemCode({ center_prod: ['ticket_type_cd'] })).forEach((o) => {
            this.ticketData = o.map((e) => e.codeDesc);
            this.ticketTypes = o.map((e) => e.codeName);
        });
        await this.loadCategories();
    },
    mounted() {
        this.load();
    },
    methods: {
        getFilterDefault() {
            return Object.keys(this.$route.query).length === 0
                ? {
                      centerId: this.centerId,
                      centerProductCategoryTemplateId: 0,
                      sortColumn: 'createAt',
                      sortType: 'DESC',
                      searchStr: '',
                      stockUseYn: 'true',
                  }
                : this.$route.query;
        },
        selectItem(id) {
            const index = this.selectedItems.indexOf(id);
            if (index >= 0) {
                this.selectedItems.splice(index, 1);
            } else {
                this.selectedItems.push(id);
            }
        },
        load(isInit) {
            if (isInit) this.pagingInfo.page = 1;
            this.filter.sortType = this.filter.sortColumn == 'createAt' ? 'DESC' : 'ASC';

            // 스웨거 검색: 센터상품 이용권 페이징 목록 조회
            api.get(`/admin/api/center/${this.centerId}/product/ticket`, {
                params: { ...this.pagingInfo, ...this.filter },
            })
                .then((res) => {
                    this.isLoading = false;
                    this.setPageParams(res.data);
                    this.data = res.data;
                })
                .catch((res) => {
                    this.isLoading = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.load(false);
        },
        async loadCategories() {
            try {
                const { data } = await api.get(`/admin/api/center/${this.centerId}/product/category/template`);
                console.log('카테고리 정보', data);
                if (data) {
                    this.categorys = data;
                    this.categorysClone = _.clone(data);
                    this.categorysData = [];
                    this.categorysValues = [];
                    data.forEach((o) => {
                        this.categorysData.push(o.name);
                        this.categorysValues.push(o.centerProductCategoryTemplateId);
                    });
                }
            } catch (e) {
                if (e.response.status != 404) alert(`오류가 발생했습니다.\n${e.response.data.message}`);
                console.error(e.toString());
            }
        },
        addCategory() {
            if (this.categorys.length < 20) {
                this.categorys.push({ centerId: this.centerId, name: '' });
            }
        },
        removeCategory(index) {
            this.categorys.splice(index, 1).forEach((o) => {
                if (o.centerProductCategoryTemplateId) {
                    this.categorysRemove.push(o);
                }
            });
        },
        saveCategorys() {
            let error = false;

            for (let i = 0; i < this.categorys.length; i++) {
                if (this.categorys[i].name.trim() == '') {
                    this.$refs[`category-${i}`][0].focus();
                    error = true;
                    break;
                }
            }

            if (error) return;

            this.isCategorySaving = true;
            api.post(`/admin/api/center/${this.centerId}/product/category/template`, {
                templates: this.categorys,
            }).then((res) => {
                if (this.categorysRemove.length) {
                    this.categorysRemove.forEach(async (o) => {
                        const res = await api.delete(
                            `/admin/api/center/${this.centerId}/product/category/template/${o.centerProductCategoryTemplateId}`,
                        );
                        console.log(res);
                    });
                    this.categorysRemove = [];
                }
                this.isCategorySaving = false;
                this.categorys = res.data.templates;
                this.categorysClone = _.clone(res.data.templates);
                this.categorysData = [];
                this.categorysValues = [];
                res.data.templates.forEach((o) => {
                    this.categorysData.push(o.name);
                    this.categorysValues.push(o.centerProductCategoryTemplateId);
                });

                this.categoryPop = false;
            }).catch((res) => {
                this.isCategorySaving = false;
                alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                console.error(res);
            });
        },
        async moveCategory() {
            try {
                if (this.selectedItems.length == 0) {
                    alert('상품을 선택해주세요.');
                    return;
                }
                if (this.categorysData.length == 0) {
                    alert('카테고리를 먼저 추가해주세요.');
                    return;
                }

                // const requests = [];
                for (const item of this.selectedItems) {
                    await api.put(`/admin/api/center/${this.centerId}/product/${item}/category/template/move`, {
                        centerProductCategoryTemplates: this.categorysClone.filter(
                            (category) => this.categorysMove.indexOf(category.centerProductCategoryTemplateId) >= 0
                        ),
                    });
                }
                this.categoryMovePop = false;
                this.loadCategories();
                this.load(true);
            } catch (error) {
                console.error(error);
            }
            // this.selectedItems.forEach(item => {
            //     requests.push(

            //         api.put(`/admin/api/center/${this.centerId}/product/${item}/category/template/move`, {
            //             centerProductCategoryTemplates: this.categorysClone.filter(
            //                 category => this.categorysMove.indexOf(category.centerProductCategoryTemplateId) >= 0
            //             ),
            //         })
            //     );
            // });

            // axios
            //     .all(requests)
            //     .then(
            //         axios.spread((...responses) => {
            //             this.categoryMovePop = false;
            //             this.loadCategories();
            //             this.load();
            //         })
            //     )
            //     .catch(errors => {
            //         console.error(errors);
            //     });
        },
        async unsetCategories() {
            if (this.selectedItems.length == 0) {
                alert('상품을 선택해주세요.');
                return;
            }
            if (this.categorysData.length == 0) {
                alert('카테고리를 먼저 추가해주세요.');
                return;
            }

            const name = this.categorysClone
                .filter(
                    (category) =>
                        category.centerProductCategoryTemplateId == this.filter.centerProductCategoryTemplateId
                )
                .pop().name;
            if (!confirm(`선택된 상품의 [${name}] 카테고리를 해제하시겠습니까?`)) return;

            const requests = [];
            for (const item of this.selectedItems) {
                try {
                    await api.delete(
                        `/admin/api/center/${this.centerId}/product/${item}/category/template/delete/${this.filter.centerProductCategoryTemplateId}`
                    );
                    this.loadCategories();
                    this.load(true);
                    this.selectedItems = [];
                } catch (error) {
                    console.error(error);
                }
            }
            // this.selectedItems.forEach(async (item) => {
            //     try {
            //         await api.delete(`/admin/api/center/${this.centerId}/product/${item}/category/template/delete/${this.filter.centerProductCategoryTemplateId}`);
            //         this.loadCategories();
            //         this.load();
            //     } catch (error) {
            //         console.error(error);
            //     }
            //     // requests.push(
            //     //     api.delete(`/admin/api/center/${this.centerId}/product/${item}/category/template/delete/${this.filter.centerProductCategoryTemplateId}`)
            //     // );
            // });

            // axios
            //     .all(requests)
            //     .then(
            //         axios.spread((...responses) => {
            //             this.categoryMovePop = false;
            //             this.selectedItems = [];
            //             this.loadCategories();
            //             this.load();
            //         })
            //     )
            //     .catch(errors => {
            //         console.error(errors);
            //     });
        },
    },
};
</script>
<style lang="scss" scoped>
.spinner-container {
    height: 120px;
}
</style>
